export default "__VITE_ASSET__Dk70I$_X__"